import React, { useEffect, useState } from 'react';
import { API_BASE_URL } from '../config';

const AuthLogin = ({ onAuthenticated, onGoBootstrap }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [bootstrapAllowed, setBootstrapAllowed] = useState(false);

  useEffect(() => {
    const checkBootstrap = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/auth/bootstrap-status`, {
          credentials: 'include',
        });
        if (!response.ok) {
          return;
        }
        const data = await response.json();
        setBootstrapAllowed(Boolean(data.allowed));
      } catch (_err) {
        setBootstrapAllowed(false);
      }
    };

    checkBootstrap();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      const payload = await response.json();

      if (!response.ok) {
        throw new Error(payload.message || 'Credenciais inválidas');
      }

      onAuthenticated(payload.user);
    } catch (err) {
      setError(err.message || 'Falha de autenticação');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-screen">
      <h2>Login</h2>
      <form onSubmit={handleSubmit} className="execution-form">
        <div className="form-group">
          <label className="form-label" htmlFor="login-username">Usuário</label>
          <input id="login-username" className="form-input" value={username} onChange={(e) => setUsername(e.target.value)} required />
        </div>
        <div className="form-group">
          <label className="form-label" htmlFor="login-password">Senha</label>
          <input id="login-password" type="password" className="form-input" value={password} onChange={(e) => setPassword(e.target.value)} required />
        </div>
        {error && <div className="alert alert-error">{error}</div>}
        <button className="btn btn-primary" type="submit" disabled={loading}>
          {loading ? 'Entrando...' : 'Entrar'}
        </button>
      </form>

      {bootstrapAllowed && (
        <button className="btn btn-secondary" onClick={onGoBootstrap} type="button">
          Criar primeiro usuário
        </button>
      )}
    </div>
  );
};

export default AuthLogin;
